import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  constructor(private authService: AuthService) { }

  // The set method is use for encrypt the value.
  set(value) {
    const at = this.authService.getAccessToken().substring(0, 16);
    const key = CryptoJS.enc.Utf8.parse(at);
    const iv = CryptoJS.enc.Utf8.parse('ABH&&%#@HKLU1239');
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

    return encrypted.toString();
  }
}
